<template>
    <!-- <img :src="'images/Background_Login.png'" class="h-full w-full" :alt="urlImageAlt" cache /> -->

    <div class="py-8 px-8 lg:py-16 lg:px-20  bg-primary min-h-screen">
        <img :src="'/images/av_hrs_putih.png'" :alt="altImageLogo" class="w-28 lg:w-40" cache />
        <h1 class="text-white font-bold mt-4 text-sm italic lg:text-xl">
            Manage Attadance, leave and payroll.
        </h1>
        <div class="rounded-xl bg-white mt-8">
            <div class="lg:px-10 md:px-6 px-4 py-8">
                <div class="flex flex-col justify-between sm:items-center gap-x-5 gap-y-5 sm:flex-row">
                    <div>
                        <h1 class="text-2xl font-semibold leading-6 text-slate-800">
                            Supports
                        </h1>
                        <p class="mt-4 text-base text-gray-600">
                            Jika memiliki pertanyaan lain atau menemukan kendala saat menggunakan aplikasi kami, segera hubungi kami melalui kontak berikut.
                        </p>
                    </div>
                </div>

                <div class="flex flex-col gap-y-3 mt-7">
                    <h4 class="font-semibold"> Email </h4>
                    <p> armadavisiondeveloper@gmail.com</p>
                    <a href="mailto:armadavisiondeveloper@gmail.com" class="text-primary"> Kontak Sekarang </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "../components/Button.vue";
import { SECRET_KEY } from "@/config";
import Loading from "@/components/Loading.vue";
import { useToast } from "vue-toastification";

export default {
    name: "Privacy And Policy",
    components: { Button, Loading },
    data() {
        return {
            altImageLogo: "Logo avapps",
            urlImageAlt: "Backgound Login Image",
            loading: false,
            capslockOn: false,
        };
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    methods: {
        detectCapsLock(event) {
            this.capslockOn =
                event.getModifierState && event.getModifierState("CapsLock");
        },
    },
};
</script>

<style scoped>
.tooltip::before {
    content: "";
    display: block;
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent #979797 transparent;
}
</style>